<template>
	<div id="app" :class="{ marginTop88:boxConfig.hasTitle }">
    <notice v-if="true"></notice>
		<title-box :titleBoxConfig="boxConfig"></title-box>
		<transition :name="'vux-pop-' + (direction === 'forward' ? 'in' : 'out')">
			<keep-alive v-if="$route.meta.keepAlive">
				<router-view></router-view>
			</keep-alive>
			<router-view v-if="!$route.meta.keepAlive"></router-view>
		</transition>
		<keep-alive v-if="$route.meta.isScroll!=1">
			<scrollTop></scrollTop>
		</keep-alive>
	</div>
</template>
<script>
import titleBox from './components/common/title'
import notice from 'components/common/notice'

import * as getters from './vuex/getters'
import { mapState } from 'vuex'
import scrollTop from 'components/common/scrollTop'
export default {
	name: 'app',
	data () {
		return {
			boxConfig: {
				showBox: false,
				hasTitle: false,
				titleContent: '',
				showCloseBtn: false,
				showTip: false,
				showBackBtn: false,
			}
		}
	},
	components: {
		scrollTop,
		titleBox,
    notice
	},
	created () {
		this.showBoxConfig();
	},
	methods: {
		showBoxConfig: function () {
 		/*
		cookie中存储的变量
		1. package_id 套餐ID
		2. activity_id 活动ID
		3. title 页面标题，非必须
		4. tip 页面提示，非必须
		5. base_id 车辆ID
		//按钮显示（具体功能待定）
		1. show_back_btn 是否显示返回按钮
		2. show_close_btn 是否显示关闭按钮
	 */
			let title = decodeURI(escape(this.getCookie("title"))),
				show_title = this.getCookie("title"),
				show_back_btn = this.getCookie("show_back_btn"),
				show_close_btn = this.getCookie("show_close_btn"),
				tip = this.getCookie("tip");
			if (!!show_title || !!show_back_btn || !!show_close_btn) {
				this.boxConfig.showBox = true;
				this.boxConfig.hasTitle = true;
				this.boxConfig.titleContent = !!title && title || "";
				this.boxConfig.showBackBtn = !!show_back_btn;
				this.boxConfig.showCloseBtn = !!show_close_btn;
			} else {
				this.boxConfig.titleContent = '首页';
			}

		}
	},
	computed: {
		...mapState({
			direction: state => {
				return state.UPDATE_DIRECTION.direction
			}
		})
	},
}
</script>
<style lang="scss" scoped>
.marginTop88 {
  margin-top: 2.2rem !important;
}
.vux-pop-out-enter-active,
.vux-pop-out-leave-active,
.vux-pop-in-enter-active,
.vux-pop-in-leave-active {
  will-change: transform;
  transition: all 250ms;
  height: 100%;
  top: 0;
  position: absolute;
  backface-visibility: hidden;
  perspective: 1000;
}

.vux-pop-out-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.vux-pop-out-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.vux-pop-in-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.vux-pop-in-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
</style>
<style lang="scss">
.answer-box-wrap {
  .activity-detail-box {
    padding: 0.5rem 0.6rem;
    .activity-detail-title {
      h5 {
        font-size: 0.75rem;
      }
      text-align: center;
      img {
        width: 14.8rem;
        height: auto;
        margin: 0 0 0.5rem;
      }
    }
    .activity-font {
      table {
        thead {
          td {
            height: 1.6rem;
            line-height: 1.6rem;
            background-color: #f7f7f7;
            .tab-left,
            .tab-right {
              text-align: center;
            }
          }
        }
        tr {
          &:nth-child(even) {
            background: #f7f7f7;
          }
          td {
            vertical-align: middle;
            font-size: 0.6rem;
            line-height: 1rem;
          }
        }
      }
      .tab-left {
        width: 4rem;
      }
      p {
        color: #282828;
        line-height: 1rem;
        font-size: 0.6rem;
        b {
          font-style: normal;
          font-weight: 400;
        }
      }
    }
  }
  .btn-box {
    position: fixed;
    bottom: 0;
    height: 2.25rem;
    width: 16rem;
    .btn-list {
      li {
        position: relative;
        z-index: 1;
        height: 1.25rem;
        padding: 0.5rem 0 0.5rem 3rem;
        &:first-child {
          border-right: 1px solid #dddedd;
        }
        h6 {
          font-size: 0.65rem;
          height: 0.85rem;
          line-height: 0.85rem;
        }
        p {
          height: 0.5rem;
          font-size: 0.5rem;
          line-height: 0.5rem;
        }
        img {
          position: absolute;
          z-index: 2;
          height: 1.25rem;
          left: 1.3rem;
          top: 0.5rem;
        }
      }
    }
  }
}
.mint-indicator-wrapper{
	padding: 1rem .8rem .5rem .8rem!important;
	border-radius: .2rem;
}
.mint-spinner-fading-circle{
	width: 1rem!important;
	height: 1rem!important;
}
.mint-indicator-text{
	font-size: .6rem;
}
</style>



// WEBPACK FOOTER //
// App.vue?69e99fee